__webpack_require__.p = "/education-admin/";